// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./error-page.gif");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".error-page:before{content:\"\";display:block;position:absolute;height:100%;width:100%;z-index:-1;z-index:var(--ring-invisible-element-z-index)}.error-page_enabled:before{background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");opacity:.06}", ""]);
// Exports
module.exports = exports;
